import { mdiCloseCircleOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { changePhoneNumberMessages, commonButtonMessages, isValidPhone, useChangeSecondaryPhoneNumberDialogLogic } from 'azshared';
import React, { FormEvent, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { AppButton, AppButtonType } from '../../../components/buttons/app-button';
import { AppDialog } from '../../../components/dialog/app-dialog';
import { AppInputText } from '../../../components/input-text/app-input-text';
import { useGlobalActions } from '../../../hooks/global-actions';
import { SearchablePrefixPicker } from '../../../components/searchable-prefix-picker/searchable-prefix-picker';

export const ChangeSecondaryPhoneNumberDialogs = () => {
  const globalActions = useGlobalActions();
  const { formatMessage } = useIntl();

  const { openDialogChangePhoneNumber, closeChangePhoneNumber,
    buttonDisabled,
    handleSubmitInsertPhoneNumber,
    phoneNumber,
    updatePhoneNumber,
    confirmNewPhoneNumber,
    updateConfirmNewPhoneNumberChangePhoneNumber,
    insertPhoneNumberChangeSecondaryPhoneNumberRequestStatus
  } = useChangeSecondaryPhoneNumberDialogLogic(globalActions);

  const onSubmitInsertPhoneNumber = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      if (!isValidPhone(phoneNumber) || !isValidPhone(confirmNewPhoneNumber)) {
        globalActions.showToast({
          type: 'error',
          title: formatMessage(changePhoneNumberMessages.errorInvalidPhoneNumberFormat),
          close: globalActions.closeToast
        });
        return;
      }
      handleSubmitInsertPhoneNumber();
    },
    [confirmNewPhoneNumber, formatMessage, globalActions, handleSubmitInsertPhoneNumber, phoneNumber]
  );

  const onCopy = useCallback((e: FormEvent) => {
    e.preventDefault();
  }, []);

  const onPaste = useCallback((e: FormEvent) => {
    e.preventDefault();
  }, []);

  return (
    <AppDialog open={openDialogChangePhoneNumber} onClose={closeChangePhoneNumber}>
      <div className='dialog-change-secondary-phone-number'>
        <div>
          <form className='form-dialog' onSubmit={onSubmitInsertPhoneNumber}>
            <div className='step-1'>
              <div className='phone-number-input-text'>
                <div className='phone-number-input-row-container'>
                  <label className='phone-number-input-label'>
                    {formatMessage(changePhoneNumberMessages.secondaryPhoneNumberlLabel)}
                  </label>
                  <SearchablePrefixPicker
                    placeholder={formatMessage(changePhoneNumberMessages.newPhoneNumberlPlaceholder)}
                    value={phoneNumber}
                    onChange={updatePhoneNumber}
                    onCopy={onCopy}
                    onPaste={onPaste}
                  />
                </div>

                <div className='phone-number-input-row-container'>
                  <label className='phone-number-input-label'>
                    {formatMessage(changePhoneNumberMessages.confirmSecondaryPhoneNumberlLabel)}
                  </label>
                  <SearchablePrefixPicker
                    placeholder={formatMessage(changePhoneNumberMessages.confirmNewPhoneNumberlPlaceholder)}
                    value={confirmNewPhoneNumber}
                    onChange={updateConfirmNewPhoneNumberChangePhoneNumber}
                    onCopy={onCopy}
                    onPaste={onPaste}
                  />
                </div>
              </div>
              <div className='button-dialog'>
                <AppButton
                  type={AppButtonType.SUBMIT}
                  label={formatMessage(changePhoneNumberMessages.changePhoneNumberGoOnButton)}
                  loading={insertPhoneNumberChangeSecondaryPhoneNumberRequestStatus === 'loading'}
                  disabled={buttonDisabled}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </AppDialog>
  );
};
